(function () {
  function initB2BCarousel() {
    var hero = document.querySelector('.b2b-hero');
    if (!hero) return;

    var slides = Array.prototype.slice.call(hero.querySelectorAll('.b2b-hero__bg-slide'));
    if (!slides || slides.length < 2) return;

    // Preload robuste (meme si certaines images sont deja en cache)
    function waitFor(img) {
      return new Promise(function (resolve) {
        if (img.complete && img.naturalWidth > 0) return resolve(true);
        img.addEventListener('load', function () { resolve(true); }, { once: true });
        img.addEventListener('error', function () { resolve(false); }, { once: true });
      });
    }

    Promise.all(slides.map(waitFor)).then(function () {
      slides.forEach(function (img, i) {
        img.classList.toggle('is-active', i === 0);
      });

      var index = 0;
      var intervalMs = 2000; // 2s par image
      var fadeMs = 700;      // fondu

      slides.forEach(function (img) {
        img.style.transitionDuration = fadeMs + 'ms';
      });

      setInterval(function () {
        var current = slides[index];
        index = (index + 1) % slides.length;
        var next = slides[index];

        current.classList.remove('is-active');
        next.classList.add('is-active');
      }, intervalMs);
    });
  }

  // DOM ready (compatible partout)
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initB2BCarousel);
  } else {
    initB2BCarousel();
  }
})();
